import React from "react";
import { ITheme } from "@fluentui/react";
import styled from "styled-components";
import Icon from "../Graphics/Icon";

const IconWrapper = styled.span`
  font-size: 16px;
  margin: 0 4px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

interface CommandBarIconProps {
  iconName?: string;
  overlayIcon?: {
    iconName: string;
    position: string;
  };
  ic: {
    iconName?: string;
    overlayIcon?: string;
    disabled?: boolean;
    theme?: ITheme;
  };
}

export const CommandBarIcon: React.FC<CommandBarIconProps> = ({ ic, iconName, overlayIcon }) => {
  const { disabled, theme } = ic;

  const color = disabled
    ? theme?.palette?.neutralTertiary
    : (theme?.palette?.themePrimary ?? "#0078d4");

  return (
    <IconWrapper>
      {iconName && (
        <Icon
          iconName={iconName}
          /* eslint-disable */
          style={{
            color,
            fontSize: 16,
            height: 16,
            width: 16,
            lineHeight: "16px",
          }}
        />
      )}
      {overlayIcon && (
        <Icon
          iconName={"circleStar"}
          /* eslint-disable */
          style={{
            position: "absolute",
            bottom: -8,
            right: -4,
            fontSize: 10,
            color: theme?.palette?.themePrimary ?? "#0078d4",
          }}
        />
      )}
    </IconWrapper>
  );
};
